import { useEffect, useState } from 'react';
import { SwitchProps, Switch, FormControlLabel } from '@mui/material';
import { useField } from '@unform/core';

type TVSwitchdProps = SwitchProps & {
  name: string;
  label: string;
  fdisabled: boolean;
  aliamento: 'end' | 'start' | 'top' | 'bottom';
  valor?: (novoValor: number) => void; // valor agora é number
};

export const VSwitchNumber: React.FC<TVSwitchdProps> = ({
  valor,
  name,
  label,
  fdisabled,
  aliamento,
}) => {
  const { fieldName, registerField, defaultValue } = useField(name);

  // Estado sempre number: 0 ou 1
  const [checked, setChecked] = useState<number>(defaultValue ?? 0);

  useEffect(() => {
    registerField({
      name: fieldName,
      getValue: () => checked,  // retorna number
      setValue: (_, newValue: number) => { // recebe number
        setChecked(newValue);
      },
    });
  }, [registerField, fieldName, checked]);

  return (
    <FormControlLabel
      control={
        <Switch
          size="small"
          checked={checked === 1}  // switch só aceita boolean
          onChange={(e) => {
            const novoValor = e.target.checked ? 1 : 0; // number
            setChecked(novoValor);
            valor?.(novoValor); // callback number
          }}
          color="primary"
          disabled={fdisabled}
        />
      }
      label={label}
      labelPlacement={aliamento}
    />
  );
};
